import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Use Sysdig to monitor your running application`}</p>
    </PageDescription>
    <p>{`In IBM Garage Method, one of the Operate practices is to `}<a parentName="p" {...{
        "href": "https://www.ibm.com/garage/method/practices/manage/practice_automated_monitoring/"
      }}>{`automate application monitoring`}</a>{`. Sysdig automates application monitoring, enabling an operator to view stats and collect metrics about a Kubernetes cluster and its deployments.
The `}<Globals name="env" mdxType="Globals" />{` includes an IBM Cloud Monitoring with Sysdig service instance configured with a Sysdig agent installed in the environment’s cluster. Simply by deploying your application into the `}<Globals name="env" mdxType="Globals" />{`, Sysdig monitors it. `}</p>
    <ul>
      <li parentName="ul">{`Open the Sysdig web UI by navigating to the openshift web console and click on 9 squares icon. It gives a list of the developer tools.`}</li>
      <li parentName="ul">{`Select SysDig and navigate to SysDig UI.`}</li>
    </ul>
    <h2>{`Sysdig Monitoring`}</h2>
    <p><a parentName="p" {...{
        "href": "https://cloud.ibm.com/docs/services/Monitoring-with-Sysdig"
      }}>{`IBM Cloud Monitoring with Sysdig`}</a>{` explains how to configure and use an instance of the Sysdig service, but the `}<Globals name="env" mdxType="Globals" />{` has already done most of this for you. You can skip steps 1-3 about user access, provisioning an instance, and installing an agent.`}</p>
    <h3>{`Sysdig dashboard`}</h3>
    <p>{`Open the Sysdig web UI for your environment’s cluster`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://cloud.ibm.com/docs/services/Monitoring-with-Sysdig?topic=Sysdig-getting-started#step4"
        }}>{`Step 4: Launch the web UI`}</a>{` explains how to open the web UI`}<ul parentName="li">
          <li parentName="ul">{`In the IBM Cloud dashboard, navigate to `}<strong parentName="li">{`Observability`}</strong>{` > `}<strong parentName="li">{`Monitoring`}</strong></li>
          <li parentName="ul">{`Find the monitoring instance named after your environment’s cluster, such as `}<inlineCode parentName="li">{`showcase-dev-iks-sysdig`}</inlineCode>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1025px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "9.027777777777777%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsSAAALEgHS3X78AAAAcklEQVQI1zWM2QoCMRRD5/8/UR8H1GEWW3vXLsRrwYdDICRnMXOIKlQN5g51nvnrWRStdVDdsfEdyVdQ7B5HQWZHJseeBNsl8WsYo2OROBXiiYZYnKBmU/YphFobSghfdMPb1ugFVya0PpCK4Xny5C/8AvQamoaEYgwuAAAAAElFTkSuQmCC')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Sysdig Monitoring Instance",
                "title": "Sysdig Monitoring Instance",
                "src": "/ibm-cloudnative-journey/static/044e438fd2e34b76850d050d863ab0e4/81b7c/sysdig-monitoring-instance.png",
                "srcSet": ["/ibm-cloudnative-journey/static/044e438fd2e34b76850d050d863ab0e4/7fc1e/sysdig-monitoring-instance.png 288w", "/ibm-cloudnative-journey/static/044e438fd2e34b76850d050d863ab0e4/a5df1/sysdig-monitoring-instance.png 576w", "/ibm-cloudnative-journey/static/044e438fd2e34b76850d050d863ab0e4/81b7c/sysdig-monitoring-instance.png 1025w"],
                "sizes": "(max-width: 1025px) 100vw, 1025px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`In the monitoring instance, press the `}<strong parentName="li">{`View Sysdig`}</strong>{` button to open the Sysdig web UI`}</li>
        </ul></li>
    </ul>
    <h3>{`Explore your application`}</h3>
    <p>{`By default, the Sysdig dashboard opens the `}<strong parentName="p">{`Explore`}</strong>{` page on its `}<strong parentName="p">{`Deployments and Pods`}</strong>{` grouping.`}</p>
    <ul>
      <li parentName="ul">{`Select your cluster`}</li>
    </ul>
    <p>{`By default, Sysdig opens its `}<strong parentName="p">{`Overview by Process`}</strong>{` dashboard, which has panels showing stats about CPU, memory, and networking.
This is one of Sysdig’s `}<strong parentName="p">{`Default Dashboards`}</strong>{` (i.e. built-in dashboards).`}</p>
    <p>{`These are the cumulative totals for all of the pods running in the cluster. Hover over a graph and a key pops up to list
the pods and show each one’s color.`}</p>
    <ul>
      <li parentName="ul">{`Expand your cluster and namespace, then select your deployment`}</li>
    </ul>
    <p>{`This shows the stats just for the pods in your deployment.`}</p>
    <p>{`On the `}<strong parentName="p">{`Dashboard`}</strong>{` page, you can create your own custom dashboards.`}</p>
    <p>{`The Getting started tutorial, starting with
`}<a parentName="p" {...{
        "href": "https://cloud.ibm.com/docs/services/Monitoring-with-Sysdig?topic=Sysdig-getting-started#step5"
      }}>{`Step 5: Monitor your environment`}</a>{`,
gives some instructions on monitoring, managing, and what to do next.`}</p>
    <h2>{`Give it a try`}</h2>
    <p>{`Before you start to understanding how to monitor your application instances, make sure you have `}<a parentName="p" {...{
        "href": "/ibm-cloudnative-journey/developer-intermediate/deploy-app"
      }}>{`deployed an app`}</a>{` into your development cluster. This `}<em parentName="p">{`Give it a Try`}</em>{` uses `}<a parentName="p" {...{
        "href": "https://github.com/IBM/template-node-typescript"
      }}>{`template-node-typescript`}</a>{` as an example.`}</p>
    <p>{`The `}<strong parentName="p">{`SysDig`}</strong>{` service is already created, bound and configured to listen to monitoring metrics and events for your development cluster. You can see this in the HTTP overview.`}</p>
    <ul>
      <li parentName="ul">{`Open the `}<strong parentName="li">{`SysDig`}</strong>{` instance that is named the same as your development cluster.`}</li>
      <li parentName="ul">{`Go to `}<strong parentName="li">{`Dashboards`}</strong>{` > `}<strong parentName="li">{`HTTP Overview`}</strong></li>
    </ul>
    <p>{`The dashboard shows stats for all incoming HTTP requests for all apps in the cluster. Browse through these views to get a feel for what they’re showing.`}</p>
    <h3>{`View your app’s metrics`}</h3>
    <p>{`Take a look at the metrics for your app.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Select the `}<strong parentName="p">{`Explore`}</strong>{` page in the left nav menu`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`On the Explore page, select the `}<strong parentName="p">{`Containerized Apps`}</strong>{` grouping`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Search for your app, e.g. `}<inlineCode parentName="p">{`hello-world-mjp`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`In the list of apps, select yours, e.g. `}<inlineCode parentName="p">{`us.icr.io/mooc-team-one/hello-world-mjp:1.0.0-10`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`With your app selected, select the `}<strong parentName="p">{`Overview by Container`}</strong>{` dashboard`}</p>
        <p parentName="li">{`  The Overview by Container dashboard shows metrics for the containers in your app. You will now see just the metrics for your your app. You can view at different levels—from pod to namespace to node to cluster—giving you a fine grain access to you monitoring requirements.`}</p>
        <p parentName="li">{`  `}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.68055555555555%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAAA+0lEQVQoz4VR7WrDMAz0+79TSSC/2l/tulcYc9IlsRN/f+Qmm2ZshXaCA0tnHSeJWWvhvEeMscKHUPOCQO+UUsXOv0JKAcwoDeccSmwERbkUC0HCWocUEzyJ5y3jv+CjBePDDbdpwtc8Q8gFb/MV7dDirM7o+g4Nb8BNj1WusM5CGwO9GnxaXrnjfIQwAmpRsD6CTbOEEILGK7YTrvIdh48DLvqCjhfBFmMcsYoVIQYoTRNQz+AHNH2DkzhhcQsE1VJOYJJcaaV+bBfhOvvvuOfbttX1lBWU92PknMHCfaF7QzlK3RmRjyjHKXz5/4xnf4yQYCnu5DO84r8B4SEfGkb0b20AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Metrics View",
              "title": "Metrics View",
              "src": "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/3cbba/appview.png",
              "srcSet": ["/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/7fc1e/appview.png 288w", "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/a5df1/appview.png 576w", "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/3cbba/appview.png 1152w", "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/0b124/appview.png 1728w", "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/4ea69/appview.png 2304w", "/ibm-cloudnative-journey/static/a02d9787bdccba1fa1f01486dcadf743/4cae6/appview.png 2864w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
    </ul>
    <h2>{`Conclusion`}</h2>
    <p>{`It’s important to be able to monitor your deployed applications.
Here, the `}<Globals name="env" mdxType="Globals" />{` uses Sysdig Monitoring, but you never had to install or run Sysdig.
Just deploy your application into the `}<Globals name="env" mdxType="Globals" />{` and it gets moniotored automatically.
After deploying your application, open the Sysdig web UI and browse the status, including the status
of your cluster as a whole and your deployment in particular.`}</p>
    <h3>{`Learn more`}</h3>
    <p>{`Learn more about using SysDig Monitoring:`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink to="https://cloud.ibm.com/docs/services/Monitoring-with-Sysdig?topic=Sysdig-monitoring" mdxType="AnchorLink">IBM Cloud Monitoring with Sysdig > Monitoring your environment</AnchorLink>
  <AnchorLink to="https://cloud.ibm.com/docs/services/Monitoring-with-Sysdig?topic=Sysdig-dashboards" mdxType="AnchorLink">IBM Cloud Monitoring with Sysdig > Working with dashboards</AnchorLink>
  <AnchorLink to="https://docs.sysdig.com/en/dashboards.html" mdxType="AnchorLink">Sysdig Monitor > Dashboards</AnchorLink>
    </AnchorLinks>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      